var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-text"},[(_vm.icon != '')?_c('feather',{attrs:{"type":_vm.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.message == '' ? _vm.getError(_vm.type) : _vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }